export default {
  root: {
    borderRadius: '4px',
    backgroundColor: 'action.selected',
    margin: 1,
    marginTop: 0,
    paddingLeft: '12px',
    paddingRight: '12px',
    '&:hover': {
      backgroundColor: 'action.hover'
    },
    '& .MuiListItemIcon-root': {
      minWidth: 0,
      color: 'action.active'
    },
    '& svg': {
      fontSize: '1.2rem',
      color: 'action.active'
    },
    '& .MuiListItemText-primary': {
      fontSize: 14,
      fontWeight: 500,
      marginLeft: '14px',
      marginRight: '14px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  },
  kgIcon: {
    width: '18px',
    height: '18px',
    minWidth: 'auto'
  },
  expandIcon: {
    width: '18px',
    height: '18px'
  },
  dialog: {
    '& .MuiDialogTitle-root .MuiButton-root': {
      float: 'right'
    },
    '& .MuiListItemText-root': {
      marginLeft: 1
    }
  }
};
